import { EmptyState, EmptyStateSize } from '@pdcplan/shared/components';
import colorVarMap from '@pdcfrontendui/components/colors';
import { currentLanguage } from '../currentLanguage';
import { useFormatter } from '../hooks/useLang';

function NoPlannedShiftsImage() {
  return (
    <svg
      width="221px"
      height="203px"
      viewBox="0 0 221 203"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="Empty-state/Illustration/NoPlannedShifts"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g transform="translate(0, 0)">
          <rect x="11.0213608" y="0" width="203" height="203"></rect>
          <path
            d="M165.232813,56.2670374 C183.922128,66.3768575 206.985537,71.24906 210.69689,82.8205408 C214.408244,94.5138267 198.767541,113.150001 193.067963,131.42076 C187.368384,149.691519 191.742479,167.596863 184.452321,177.341268 C177.162163,187.207478 158.207752,189.034554 142.434501,187.207478 C126.661249,185.502207 113.93661,180.26459 95.114747,181.117225 C76.4254325,181.848056 51.6388949,188.669139 34.2750637,182.700691 C17.0437809,176.732243 7.10265613,157.852459 10.4163644,140.79975 C13.7300726,123.868846 30.2986138,108.521409 38.7817069,89.3980141 C47.3973483,70.2746195 48.06009,47.2534629 59.8568913,34.2203213 C71.6536927,21.1871798 94.717102,18.0202482 113.406417,24.2323063 C132.095731,30.4443644 146.410951,46.0354123 165.232813,56.2670374 Z"
            fill={colorVarMap.colorPrimaryLightest}
            fillRule="nonzero"
            transform="translate(110.5214, 104.5) rotate(-7.3085) translate(-110.5214, -104.5)"
          ></path>
          <rect
            fill={colorVarMap.colorPrimaryUltraLightest}
            x="61"
            y="76"
            width="96"
            height="71"
          ></rect>
          <path
            d="M125.474379,54.3779606 C128.441612,54.3779606 130.851134,56.7914155 130.851134,59.7651571 L130.851134,70.5395501 L157.732842,70.5395501 C160.700076,70.5395501 163.108564,72.9531086 163.108564,75.9268501 L163.108564,145.960508 C163.108564,148.934767 160.700076,151.348119 157.732842,151.348119 L60.9580713,151.348119 C57.9903216,151.348119 55.5816263,148.934767 55.5816263,145.960508 L55.5816263,75.9268501 C55.5816263,72.9531086 57.9903216,70.5395501 60.9580713,70.5395501 L87.83978,70.5395501 L87.83978,59.7651571 C87.83978,56.7914155 90.248372,54.3779606 93.2161218,54.3779606 L125.474379,54.3779606 Z M152.356087,140.572898 L152.356087,81.3140467 L66.3344131,81.3140467 L66.3344131,140.572898 L152.356087,140.572898 Z M120.097624,65.1523536 L98.5924635,65.1523536 L98.5924635,70.5395501 L120.097624,70.5395501 L120.097624,65.1523536 Z"
            fill={colorVarMap.colorPrimaryDark}
            fillRule="nonzero"
          ></path>
          <ellipse
            fill={colorVarMap.colorPrimaryDark}
            cx="110.020931"
            cy="124.95469"
            rx="5.6224479"
            ry="5.73178516"
          ></ellipse>
          <path
            d="M170.64064,66.2490861 L170.64064,62.1175977 L178.001363,53.4993901 C179.209591,52.0939118 180.103453,51.0977212 180.682948,50.5030957 C180.079213,50.5417078 179.283827,50.564875 178.297549,50.5803198 L171.362547,50.6189319 L171.362547,46.2248816 L187.599771,46.2248816 L187.599771,49.977972 L180.091333,58.8046846 L177.446866,61.7237549 C178.889165,61.6388084 179.783026,61.5924739 180.128451,61.5924739 L188.173206,61.5924739 L188.173206,66.2490861 L170.64064,66.2490861 Z"
            fill={colorVarMap.colorPrimaryBaseDark}
            fillRule="nonzero"
          ></path>
          <path
            d="M148.844333,42.0045313 L148.844333,35.4490419 L159.870358,21.7744134 C161.680228,19.5443216 163.019192,17.9636522 163.887249,17.0201518 C162.982881,17.0814181 161.79143,17.1181779 160.314031,17.1426844 L149.925716,17.2039506 L149.925716,10.2318506 L174.248331,10.2318506 L174.248331,16.1869308 L163.001036,30.192397 L159.039746,34.824126 C161.200244,34.6893403 162.539207,34.6158208 163.056637,34.6158208 L175.10731,34.6158208 L175.10731,42.0045313 L148.844333,42.0045313 Z"
            fill={colorVarMap.colorPrimaryBaseDark}
            fillRule="nonzero"
          ></path>
          <path
            d="M82.1215097,101.08735 C83.4320001,104.81492 86.6959411,107.307969 90.3558818,107.307969 C94.0140188,107.307969 97.2755918,104.819396 98.5881939,101.095514 L100.787861,101.870857 C99.1569283,106.497851 95.0383936,109.640284 90.3558818,109.640284 C85.6707495,109.640284 81.5494956,106.492406 79.9212119,101.860902 L82.1215097,101.08735 Z"
            fill={colorVarMap.colorPrimaryDark}
            fillRule="nonzero"
          ></path>
          <path
            d="M121.12151,101.08735 C122.432,104.81492 125.695941,107.307969 129.355882,107.307969 C133.014019,107.307969 136.275592,104.819396 137.588194,101.095514 L139.787861,101.870857 C138.156928,106.497851 134.038394,109.640284 129.355882,109.640284 C124.670749,109.640284 120.549496,106.492406 118.921212,101.860902 L121.12151,101.08735 Z"
            fill={colorVarMap.colorPrimaryDark}
            fillRule="nonzero"
          ></path>
        </g>
      </g>
    </svg>
  );
}

export default function NoPlannedShifts({
  className,
  from,
  to,
}: {
  className?: string;
  from: Date;
  to: Date;
}) {
  const formatter = useFormatter();
  return (
    <EmptyState
      className={className}
      image={NoPlannedShiftsImage}
      heading={currentLanguage.NothingPlanned}
      description={currentLanguage.NothingPlannedForGroup_2(
        formatter.dayDescription(from, false),
        formatter.dayDescription(to, true)
      )}
      size={EmptyStateSize.Large}
    />
  );
}
